module.exports = "/images/vendor/flag-icon-css/flags/4x3/st.svg?1f545eb99b323d22b91e51b9e56df808";